import {
  PRIORITY_LOW,
  PRIORITY_NORMAL,
  PRIORITY_HIGH,
  PRIORITY_URGENT
} from './priorities';

import {
  CITY,
  BOOKING_ID,
  MOVE_IN_DATE,
  NAME,
  EMAIL,
  COMMENT,
  RENTABLE_UNIT_ID
} from './formFields';

export const COMMUNICATION_ISSUES = 'communication_issues';
export const TENANT_DATES_MODIFICATIONS = 'tenant_dates_modification';
export const TENANT_BC_CANCELLATION = 'tenant_bc_cancellation';
export const TENANT_BOOKING_STATUS = 'tenant_booking_status';
export const LISTING_INACCURACY = 'listing_inaccuracy';
export const PROPERTY_CONDITIONS = 'property_conditions';
export const PERSONAL_CONFLICT = 'personal_conflict';
export const LAST_MINUTE_CANCEL = 'last_minute_cancel';
export const DESPOSIT_DISPUTE = 'deposit_dispute';
export const TENANT_WRONG_CONTRACT = 'tenant_wrong_contract';
export const REQUEST_INVOICE = 'request_invoice';
export const LIST_PAYMENTS = 'list_payments';
export const LISTING_DOUBTS = 'listing_doubts';
export const HELP_FIND_PROPERTY = 'help_find_property';
export const TENANT_BUG = 'tenant_bug';
export const TENANT_ACCOUNT_ACCESS = 'tenant_account_access';
export const TENANT_CHANGE_ACCOUNT_DETAILS = 'tenant_change_account_details';
export const TENANT_OTHER = 'tenant_other';

export const TENANT_REASON_IDS = [
  COMMUNICATION_ISSUES,
  TENANT_DATES_MODIFICATIONS,
  TENANT_BC_CANCELLATION,
  TENANT_BOOKING_STATUS,
  LISTING_INACCURACY,
  PROPERTY_CONDITIONS,
  PERSONAL_CONFLICT,
  LAST_MINUTE_CANCEL,
  DESPOSIT_DISPUTE,
  TENANT_WRONG_CONTRACT,
  REQUEST_INVOICE,
  LIST_PAYMENTS,
  LISTING_DOUBTS,
  HELP_FIND_PROPERTY,
  TENANT_BUG,
  TENANT_ACCOUNT_ACCESS,
  TENANT_CHANGE_ACCOUNT_DETAILS,
  TENANT_OTHER
];

const BOOKING_FORM_FIELDS = [
  CITY,
  BOOKING_ID,
  NAME,
  MOVE_IN_DATE,
  EMAIL,
  COMMENT
];
const NON_BOOKING_FORM_FIELDS = [NAME, EMAIL, COMMENT];

export const TENANT_REASONS = {
  [COMMUNICATION_ISSUES]: {
    zendesk: {
      priority: PRIORITY_HIGH,
      subject: {
        prefix: 'I have troubles to get in touch with my LL',
        suffix: 'bookingId'
      },
      tags: ['communication_issues']
    },
    form: {
      fields: BOOKING_FORM_FIELDS,
      helpCenterArticles: [
        'articles/213527365-Help-I-ve-moved-in-and-have-an-issue-with-my-property'
      ]
    }
  },
  [TENANT_DATES_MODIFICATIONS]: {
    zendesk: {
      priority: PRIORITY_NORMAL,
      subject: {
        prefix: 'I want to modify my booking dates',
        suffix: 'bookingId'
      },
      tags: ['dates_modification']
    },
    form: {
      fields: BOOKING_FORM_FIELDS,
      helpCenterArticles: ['articles/213527525-Changes-in-my-dates']
    }
  },
  [TENANT_BC_CANCELLATION]: {
    zendesk: {
      priority: PRIORITY_HIGH,
      subject: { prefix: 'I want to cancel my booking', suffix: 'bookingId' },
      tags: ['bc_cancellation']
    },
    form: {
      fields: BOOKING_FORM_FIELDS,
      helpCenterArticles: [
        'articles/360014828780-What-is-Spotahome-s-Cancellation-policy'
      ]
    }
  },
  [TENANT_BOOKING_STATUS]: {
    zendesk: {
      priority: PRIORITY_NORMAL,
      subject: {
        prefix: 'I want to know the status of my booking',
        suffix: 'bookingId'
      },
      tags: ['booking_update']
    },
    form: {
      fields: BOOKING_FORM_FIELDS,
      helpCenterArticles: ['articles/360014866599-My-Bookings']
    }
  },
  [LISTING_INACCURACY]: {
    zendesk: {
      priority: PRIORITY_NORMAL,
      subject: {
        prefix: 'Listing inaccuracy',
        suffix: 'bookingId'
      },
      tags: ['listing_inaccuracy']
    },
    form: {
      fields: BOOKING_FORM_FIELDS,
      helpCenterArticles: [
        'articles/213527365-Help-I-ve-moved-in-and-have-an-issue-with-my-property'
      ]
    }
  },
  [PROPERTY_CONDITIONS]: {
    zendesk: {
      priority: PRIORITY_HIGH,
      subject: {
        prefix: 'Property conditions',
        suffix: 'bookingId'
      },
      tags: ['property_conditions']
    },
    form: {
      fields: BOOKING_FORM_FIELDS,
      helpCenterArticles: [
        'articles/213527365-Help-I-ve-moved-in-and-have-an-issue-with-my-property'
      ]
    }
  },
  [PERSONAL_CONFLICT]: {
    zendesk: {
      priority: PRIORITY_HIGH,
      subject: {
        prefix: 'Personal conflict',
        suffix: 'bookingId'
      },
      tags: ['personal_conflict']
    },
    form: {
      fields: BOOKING_FORM_FIELDS,
      helpCenterArticles: [
        'articles/213527365-Help-I-ve-moved-in-and-have-an-issue-with-my-property'
      ]
    }
  },
  [LAST_MINUTE_CANCEL]: {
    zendesk: {
      priority: PRIORITY_URGENT,
      subject: {
        prefix: 'Last minute cancellation',
        suffix: 'bookingId'
      },
      tags: ['last_minute_cancel']
    },
    form: {
      fields: BOOKING_FORM_FIELDS,
      helpCenterArticles: [
        'articles/360015668740-Spotahome-Guarantees-and-Force-Majeure-for-Tenants',
        'articles/213527365-Help-I-ve-moved-in-and-have-an-issue-with-my-property'
      ]
    }
  },
  [DESPOSIT_DISPUTE]: {
    zendesk: {
      priority: PRIORITY_LOW,
      subject: {
        prefix: 'Deposit dispute',
        suffix: 'bookingId'
      },
      tags: ['security_deposit']
    },
    form: {
      fields: BOOKING_FORM_FIELDS,
      helpCenterArticles: ['articles/213524645-About-the-Security-Deposit']
    }
  },
  [TENANT_WRONG_CONTRACT]: {
    zendesk: {
      priority: PRIORITY_NORMAL,
      subject: {
        prefix: 'My contract is wrong',
        suffix: 'bookingId'
      },
      tags: ['administrative_issues']
    },
    form: {
      fields: BOOKING_FORM_FIELDS,
      helpCenterArticles: ['articles/213018409-My-Contract']
    }
  },
  [REQUEST_INVOICE]: {
    zendesk: {
      priority: PRIORITY_NORMAL,
      subject: {
        prefix: 'I need an invoice',
        suffix: 'bookingId'
      },
      tags: ['finance_request']
    },
    form: {
      fields: BOOKING_FORM_FIELDS,
      helpCenterArticles: ['articles/360014830300-My-Payments']
    }
  },
  [LIST_PAYMENTS]: {
    zendesk: {
      priority: PRIORITY_HIGH,
      subject: {
        prefix: 'My payments',
        suffix: 'bookingId'
      },
      tags: ['payment_request']
    },
    form: {
      fields: BOOKING_FORM_FIELDS,
      helpCenterArticles: [
        'articles/213526385-Why-has-my-payment-method-failed'
      ]
    }
  },
  [LISTING_DOUBTS]: {
    zendesk: {
      priority: PRIORITY_NORMAL,
      subject: {
        prefix: 'Listing doubts',
        suffix: 'city' // @TO-DO: Rentable Unit ID input not available yet
      },
      tags: ['listing_doubts']
    },
    form: {
      fields: [NAME, EMAIL, CITY, RENTABLE_UNIT_ID, COMMENT],
      helpCenterArticles: ['/sections/360003353339-House-and-Rules']
    }
  },
  [HELP_FIND_PROPERTY]: {
    zendesk: {
      priority: PRIORITY_LOW,
      subject: {
        prefix: 'Help me find a property',
        suffix: 'city'
      },
      tags: ['lead_tenant']
    },
    form: {
      fields: [NAME, EMAIL, CITY, COMMENT],
      helpCenterArticles: [
        'articles/213518185-How-do-I-search-for-my-new-home-'
      ]
    }
  },
  [TENANT_BUG]: {
    zendesk: {
      priority: PRIORITY_LOW,
      subject: {
        prefix: 'Report a bug',
        suffix: 'tenant'
      },
      tags: ['bug_report']
    },
    form: {
      fields: NON_BOOKING_FORM_FIELDS,
      helpCenterArticles: []
    }
  },
  [TENANT_ACCOUNT_ACCESS]: {
    zendesk: {
      priority: PRIORITY_NORMAL,
      subject: {
        prefix: 'I can not access my account',
        suffix: 'tenant'
      },
      tags: ['login_issues']
    },
    form: {
      fields: NON_BOOKING_FORM_FIELDS,
      helpCenterArticles: ['articles/360014830020-Create-and-Manage-My-Account']
    }
  },
  [TENANT_CHANGE_ACCOUNT_DETAILS]: {
    zendesk: {
      priority: PRIORITY_NORMAL,
      subject: {
        prefix: 'How to change my account detail',
        suffix: 'tenant'
      },
      tags: ['change_accountdetails']
    },
    form: {
      fields: NON_BOOKING_FORM_FIELDS,
      helpCenterArticles: ['articles/360014830020-Create-and-Manage-My-Account']
    }
  },
  [TENANT_OTHER]: {
    zendesk: {
      priority: PRIORITY_NORMAL,
      subject: {
        prefix: 'Other questions',
        suffix: 'tenant'
      },
      tags: ['other']
    },
    form: {
      fields: NON_BOOKING_FORM_FIELDS,
      helpCenterArticles: ['categories/115000891985-Tenants']
    }
  }
};
